var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBundles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_3182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4868 0.694646L4.43435 8.68544C4.22946 8.79422 4.05805 8.95673 3.93851 9.15554C3.81898 9.35435 3.75584 9.58196 3.75586 9.81394V29.8724C3.75585 30.2697 3.8659 30.6593 4.07378 30.9978C4.28167 31.3364 4.57928 31.6107 4.93359 31.7904L19.6943 39.2771C19.9265 39.3949 20.1832 39.4563 20.4435 39.4563C20.7039 39.4563 20.9606 39.3949 21.1928 39.2771L35.9536 31.7904C36.3079 31.6107 36.6055 31.3364 36.8134 30.9978C37.0213 30.6592 37.1313 30.2697 37.1313 29.8724V9.81394C37.1314 9.58194 37.0682 9.35432 36.9487 9.1555C36.8291 8.95669 36.6576 8.79419 36.4527 8.68544L21.4004 0.694646C21.1057 0.538295 20.7772 0.456543 20.4436 0.456543C20.11 0.456543 19.7815 0.538295 19.4868 0.694646Z",
    fill: "#FFCE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4438 39.4566C20.7007 39.4566 20.9577 39.3969 21.1931 39.2774L35.9539 31.7907C36.3082 31.611 36.6058 31.3367 36.8137 30.9981C37.0216 30.6595 37.1317 30.27 37.1317 29.8727V9.81398C37.1309 9.60927 37.0808 9.40777 36.9855 9.22656L20.4438 18.0368V39.4566Z",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4437 18.037L3.90212 9.22656C3.80679 9.40774 3.75662 9.60925 3.75586 9.81398V29.8726C3.75585 30.2699 3.8659 30.6594 4.07378 30.998C4.28167 31.3365 4.57928 31.6109 4.93359 31.7906L19.6943 39.2773C19.9265 39.3951 20.1832 39.4565 20.4435 39.4564L20.4437 18.037Z",
    fill: "#E2791B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.341 3.31738L9.6001 12.2327V15.0854C9.60012 15.2198 9.63665 15.3516 9.7058 15.4669C9.77495 15.5821 9.87411 15.6763 9.99267 15.7395L12.902 17.2902C13.1329 17.4132 13.4116 17.2459 13.4116 16.9843V14.3218L30.1784 5.35458L26.341 3.31738Z",
    fill: "#DEF2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8555 33.764L27.3215 31.628C27.6015 31.4942 27.8367 31.2823 27.9991 31.0178C28.1614 30.7534 28.2438 30.4477 28.2364 30.1375L28.236 30.1177C28.2236 29.5949 27.6687 29.2651 27.2035 29.504L22.8556 31.7369V33.764H22.8555ZM22.8555 36.8785L25.308 35.7391C25.5921 35.6071 25.8316 35.395 25.997 35.1288C26.1624 34.8627 26.2466 34.5541 26.2392 34.2408C26.2268 33.7162 25.6687 33.3865 25.2033 33.6288L22.8555 34.8512V36.8785Z",
    fill: "#403A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 12.2612V15.0853C9.60012 15.2197 9.63665 15.3515 9.7058 15.4667C9.77495 15.5819 9.87411 15.6762 9.99267 15.7394L12.902 17.29C13.1329 17.413 13.4116 17.2458 13.4116 16.9842V14.3217L13.4399 14.3065L9.6001 12.2612Z",
    fill: "#B6C8CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_3182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(0.943848 0.456543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundles);
export default __webpack_public_path__ + "static/media/bundles.f14b3e963a23c18193dc42f402775795.svg";
export { ForwardRef as ReactComponent };